import { BaseConnector } from './baseConnector';

class InvitationGroupConnector extends BaseConnector {
  getInvitationGroups() {
    var url = `${this.baseApiUrl}/invitationGroup`;
    return this.authFetch(url);
  }

  updateInvitationGroup(invitationGroupId, invitationGroup) {
    var url = `${this.baseApiUrl}/invitationGroup/${invitationGroupId}`;
    return this.authPatch(url, invitationGroup);
  }

  createInvitationGroup(invitationGroup) {
    var url = `${this.baseApiUrl}/invitationGroup`;
    return this.authPost(url, invitationGroup);
  }

  deleteInvitationGroup(invitationGroupId) {
    var url = `${this.baseApiUrl}/invitationGroup/${invitationGroupId}`;
    return this.authDelete(url);
  }
}

export { InvitationGroupConnector };
